import React from 'react'
import { Grid, Container, Typography, withStyles } from '@material-ui/core'
import { getArticle } from '../../Helpers/ArticleHelpers'
import moment from 'moment'
import Loading from '../Loading/Loading'

const styles = theme => ({
    articleImage: {
        width: '100%'
    },
    title: {
        fontWeight: 'bold'
    },
    articleContainer: {
        "& *": {
            fontFamily: "'Open Sans', sans-serif !important"
        }
    },
    articleContent: {
        fontSize: "1.3rem"
    }
})

class ArticleView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            article: null
        }
        this.getArticle()
    }

    getArticle = async () => {
        const article = await getArticle(this.props.match.params.articleId)
        this.setState({ article })
    }
    render() {
        const article = this.state.article
        const { classes } = this.props
        return (
            <div>
                <Container>
                    <Grid container>
                        <Grid item md={10} xs={12}>
                            {article ? 
                                <div className={classes.articleContainer}>
                                    <Typography className={classes.title} variant="h2">{article.title}</Typography>
                                    <Typography variant="caption">{article.authorName} | {moment(article.time.seconds * 1000).format("LL")}</Typography>
                                    <img src={article.imageURL} alt={article.title} className={classes.articleImage} />
                                    <Typography className={classes.articleContent} variant="body1" dangerouslySetInnerHTML={{ __html: article.content }} />
                                </div>

                            :   
                                <Loading />
                            }
                        </Grid>
                    </Grid>
                </Container>
            </div>
        )
    }
}

export default withStyles(styles)(ArticleView)